export const MOUSE = {
  LEFT: 0,
  WHEEL: 1,
  RIGHT: 2
}